import FirstAsset from "./FirstAsset";
import ManualForm from "./ManualForm";
import UploadForm from "./UploadForm";

export { ManualForm, UploadForm };
export default FirstAsset;
